<!--AFFICHAGE BLOC GOOGLE -->
<template>
  <v-container v-if="this.condition()" fluid >
    <a class="anchor" id="blocunite"></a>

    <v-row dense>
      <v-col cols="12">
        <v-card elevation="2" >

          <v-card-title>
            Entreprise
            <SimpleChips
                icon="mdi-alpha-u-circle-outline"
                :value="
            administratif_donnes.etatAdministratifUniteLegale.valeur
          "
            ></SimpleChips>
          </v-card-title>

          <v-simple-table>
            <tbody>
            <tr>
              <td>Situation</td>
              <td>{{
                  this.situation
                }}
              </td>
            </tr>
            <SimpleTr
                :var="administratif_donnes"
                data="dateCreationUniteLegale"
                field="libelle"
                prefix="Créée le : "
            ></SimpleTr>
            <tr>
              <td>Siren</td>
              <td><a target="_blank" @click="displaySelected(identite.siren.valeur)">
                <v-icon x-small>mdi-open-in-new</v-icon>
                {{ identite.siren.valeur }}</a>
              </td>
            </tr>
            <SimpleTr
                :var="administratif_donnes"
                data="categorieJuridiqueUniteLegale"
                field="mix"
                prefix="Forme juridique : "
            ></SimpleTr>
            <SimpleTr
                :var="administratif_donnes"
                data="categorieEntreprise"
                field="libelle"
                prefix="Catégorie : "
            ></SimpleTr>

            <SimpleTr
                :var="administratif_donnes"
                data="activitePrincipaleUniteLegale"
                field="mix"
                prefix="Activité : "
            ></SimpleTr>

            <SimpleTr
                :var="administratif_donnes"
                data="secondaryActivities"
                field="libelle"
                prefix="Activité secondaire : "
            ></SimpleTr>

            <SimpleTr
                :var="administratif_donnes"
                data="declaredActivity"
                alt_data="activiteDeclareInpi"
                field="libelle"
                prefix="Activité déclarée : "
            ></SimpleTr>
             <SimpleTr
                :var="administratif_donnes"
                data="origineFondsInpi"
                field="libelle"
                prefix="Origine fonds : "
            ></SimpleTr>
             <SimpleTr
                :var="finance_donnes"
                data="capitalSocialInpi"
                field="libelle"
                prefix="Capital social : "
            ></SimpleTr>
            <SimpleTr
                :var="administratif_indicateur"
                :suffix="' ('+administratif_indicateur.anneeEffectifsUniteLegale.valeur+', source: INSEE)'"
                data="trancheEffectifsUniteLegale"
                field="libelle"
                prefix="Effectifs : "
            ></SimpleTr>

            <!--
            <SimpleTr
                :var="administratif_donnes"
                data="evolutionEffectif"
                field="valeur"
                :prefix="'Dernier Effectif : '"
            ></SimpleTr>
            -->

            <SimpleTr
                :var="administratif_indicateur"
                data="effectifsUniteLegale-infolegale"
                :suffix="' ('+administratif_indicateur.anneeEffectifsUniteLegale.valeur+', source: Infolegale)'"
                field="libelle"
                prefix="Effectifs détaillés : "
            ></SimpleTr>

            <SimpleTr
                :value="ccn_calcule"
                prefix="CCN Calculée : "
            ></SimpleTr>

            <SimpleTr
                :var="administratif_donnes"
                data="identifiantAssociationUniteLegale"
                field="libelle"
                prefix="Identifiant association : "
            ></SimpleTr>

            <SimpleTr
                :var="administratif_donnes"
                data="economieSocialeSolidaireUniteLegale"
                field="libelle"
                prefix="Economie sociale et solidaire : "
            ></SimpleTr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SimpleTr from "@/components/layout/SimpleTr.vue";
import SimpleChips from "@/components/layout/SimpleChips.vue";

export default {
  name: "Administratif",
  props: ["etablissement"],
  components: {
    SimpleTr,
    SimpleChips,
  },
  computed: {
    situation: function () {
      try {
        var donnees = this.$store.getters.getbloc("administratif", "donnees")
        if (donnees != undefined && donnees.etatAdministratifUniteLegale != undefined && donnees.etatAdministratifUniteLegale.valeur == "C") {
          return "Cessé le " + donnees.dateDebutPeriodeUniteLegale.libelle
        } else {
          return "Actif"
        }
      } catch (e) {
        console.log(e)
        return "Etat inconnu"
      }
    },


    administratif_donnes: function () {
      return this.condition() ? this.etablissement.administratif.donnees : {};
    },
     finance_donnes: function () {
      return this.condition() ? this.etablissement.finance.donnees : {};
    },
    administratif_indicateur: function () {
      return this.condition()
          ? this.etablissement.administratif.indicateurs
          : {};
    },
    identite: function () {
      return this.condition() ? this.etablissement.identite.donnees : {};
    },
    ccn_calcule: function () {
      var ccn = this.$store.getters.getbloc("administratif", "indicateurs", "ccn_unite", null, "valeur")
      if (ccn == null || !ccn["ccn_libelle"]) {
        return null
      } else {
        return ccn["ccn_libelle"] + " (" + ccn["ccn_proba"] + ")"
      }
    },
  },
  methods: {
    condition() {
      return (
          this.etablissement &&
          "administratif" in this.etablissement &&
          "donnees" in this.etablissement.administratif
      );
    },
     displaySelected(siret) {
        this.$store.dispatch('getEtablissement',siret)
    },
  },
};
</script>
